import { useState } from "react";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "克制表述",
    text: "无法核实的线索用“网传 / 待证实”呈现，不做主观定罪，也不为流量渲染未经证实的指控。",
  },
  {
    icon: "ri-check-double-line",
    title: "多方求证",
    text: "优先采用官方公告、可靠文件与多方交叉验证，证据不足的内容会持续标注进展，而非默认采信。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重隐私",
    text: "拦截涉及未成年人、个人隐私与严肃法律的内容，投稿信息默认匿名，不公开展示可识别身份的信息。",
  },
  {
    icon: "ri-refresh-line",
    title: "随时更正",
    text: "发现事实错误或当事人给出回应，第一时间补充更正说明并更新核实状态，把澄清同样重要地呈现。",
  },
];

export default function About() {
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <section
      id="about"
      className="w-full bg-background-50 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">
              ABOUT US
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              关于我们
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              大瓜预警是一档聚焦泛娱乐与圈内动态的爆料资讯栏目。我们相信，真正有价值的“瓜”，
              不是情绪的狂欢，而是有据可查、可以持续跟进的信息。因此从立项起，我们把
              <strong className="text-foreground-950">“核实状态”</strong>
              做成每一篇内容的标准配置，把
              <strong className="text-foreground-950">“不造谣、不传谣”</strong>
              写进编辑底线。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们的定位是信息的“整理者”而非“传播放大器”：收集匿名投稿与公开线索，
              用清晰的判断标准把它们整理成可追踪的线索流，帮助你在信息过载里快速分清哪些能聊、
              哪些待证、哪些以官方为准。
            </p>

            <div className="mt-5 rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5">
              <p className="text-xs font-semibold text-secondary-800">联系方式</p>
              <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-foreground-800">
                <a
                  href="mailto:hello@daguayujing.cn"
                  className="inline-flex items-center gap-2 whitespace-nowrap hover:text-primary-700"
                >
                  <i className="ri-mail-line" />
                  hello@daguayujing.cn
                </a>
                <button
                  type="button"
                  onClick={() => setContactOpen((v) => !v)}
                  className="inline-flex items-center gap-2 whitespace-nowrap text-foreground-800 hover:text-primary-700"
                >
                  <i className="ri-chat-3-line" />
                  纠错与申诉
                  <i className="ri-arrow-down-s-line" />
                </button>
              </div>
              {contactOpen && (
                <p className="mt-3 animate-fadeUp text-xs leading-relaxed text-foreground-600">
                  若你发现内容有误或认为涉及不实描述，请前往下方“匿名投稿”并选择“纠错 / 申诉”
                  提交说明，我们将尽快核实并更新更正信息。
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                  <i className={`${p.icon} text-xl`} />
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
                  {p.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}